import React from "react";
import { OrderMissionEntity } from "@src/features/order/entities";
import HistoryOrderRoute from "../history-order-route";

interface CancelledMapProps {
  order: OrderMissionEntity;
}

const CancelledMap: React.FC<CancelledMapProps> = ({ order }) => {
  if (!order) return null;
  return <HistoryOrderRoute order={order} droneVariant="idleGray" />;
};

export default CancelledMap;
